

/* UI helpers */
export const CONTEXT = "project_proposals";
// export const UPLOAD_PATH = "upload_path"+"/"+CONTEXT
// export const SEARCHABLE = [""];

/* Routing helpers */
export const ROUTE_PREFIX = "/"+CONTEXT;
// export const ROUTES = {
//   new : { path: `${ROUTE_PREFIX}/new`, component: Edit },
//   edit : { path: `${ROUTE_PREFIX}/:slug/edit`, component: Edit },
//   details : { path: `${ROUTE_PREFIX}/:slug/details`, component: Details },
//   list : { path: `${ROUTE_PREFIX}/list`, component: List },
//   myProjects : { path: `${ROUTE_PREFIX}/my-projects`, component: List },
//   saved : { path: `${ROUTE_PREFIX}/saved`, component: List },
// }

// export const ROUTE_DEFAULT = ROUTES.list.path;
// export const CONTEXT_TITLE = {
//   singular: "EMY_PROJECT",
//   plural: "EMY_PROJECTS",
// }







